import {JsonProperty} from '@hyperloris/tyson';

export class CalculateRequest {
  @JsonProperty()
  heatOilAveragePrice: number = undefined;

  @JsonProperty()
  gasOilPrices: number[] = undefined;

  @JsonProperty()
  conversionRate: number = undefined;
}
